module.exports = __webpack_public_path__ + "img/usdc.8411270f.png";